<template lang="pug">
  .exchange-goods-panel-container(v-platform-expose="handleGoodsModuleExpose")
    .panel-header
      .header-left
        .title {{ moduleConfig.mainTitle }}
        //- 图标 + 副标题（富文本），subtitleLogoSwitch 控制图标渲染
        .header-subtitle
          img.subtitle-logo(
            v-if="moduleConfig.subtitleLogoSwitch && moduleConfig.subtitleLogo"
            :src="moduleConfig.subtitleLogo"
          )
          HighlightText.subtitle-text(
            v-if="moduleConfig.subtitle"
            :text="moduleConfig.subtitle"
            :normalStyle="subtitleNormalStyle"
            :highlightStyle="subtitleHighlightStyle"
          )
      .more-btn(@click="handleMoreClick")
        .text 更多兑换
        img.arrow(
          src="https://m.hellobike.com/15e7879a35.png"
          alt=""
        )
    .panel-content
      .goods-select-list
        .goods-select-item(
          v-for="(item, index) in exchangeGoodsList"
          @click="handleBtnClick(item, index)"
        )
          SafeImage(class="goods-logo" :src="item.image" pureBgColor="#f0f3f5" alt="" )
          .goods-tip(
            v-if="item.salePriceAfterDeduction"
          )
            .goods-tip-text 现金补差额
          .goods-select-item-bounty
            img.bounty-icon(
              src="https://m.hellobike.com/82cd0c93_image%201276.png"
              alt=""
            )
            .bounty-text {{ item.amount }}兑
</template>

<script>
import { SafeImage, HighlightText } from '@hb/platformui-h5';
import SPM from '@/pages/welfare/common/spm';
import { SUBTITLE_NORMAL_STYLE, SUBTITLE_HIGHLIGHT_STYLE } from '../../consts';

export default {
  name: 'ExchangeSelection',
  components: {
    SafeImage,
    HighlightText,
  },
  props: {
    // 兑换商品列表
    exchangeGoodsList: {
      type: Array,
      default: () => [],
    },
    // 奖励金数量
    points: {
      type: Number,
      default: 0,
    },
    moduleConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 可配置副标题文本样式（统一常量）
      subtitleNormalStyle: SUBTITLE_NORMAL_STYLE,
      subtitleHighlightStyle: SUBTITLE_HIGHLIGHT_STYLE,
    };
  },
  methods: {
    // 兑换商品按钮点击
    handleBtnClick(item, index) {
      this.$emit('exchange', item);
      SPM.clickButton({
        buttonName: 'platform_exchangeButton',
        businessInfo: {
          rankNum: index + 1,
          skuId: item.skuId,
          spuId: item.skuId,
          goodsName: item.title,
          exchangeNeedCash: item.salePriceAfterDeduction,
          exchangebonus: item.pointsDeduction,
          exchangeTotalBonus: item.cost,
          isSupportCash: !!(item.pointsDeduction && item.salePriceAfterDeduction),
        },
      });
    },
    // 更多兑换点击
    handleMoreClick() {
      this.$emit('moreClick');
      SPM.clickButton({
        buttonName: 'platform_moreExchange',
        businessInfo: {},
      });
    },
    // 商品模块曝光
    handleGoodsModuleExpose() {
      const { skuId = '' } = this.exchangeGoodsList[0] || {};
      // 商品兑换模块曝光
      SPM.moduleExpose({
        moduleId: 'platform_exchangeSelection',
        contentId: 'platform_exchangeSelection',
        businessInfo: {
          spuId: skuId,
        },
      });
      // 商品列表曝光
      this.exchangeGoodsList.forEach((item, index) => {
        SPM.moduleExpose({
          moduleId: 'platform_exchangeCard',
          contentId: 'platform_exchangeCard',
          businessInfo: {
            rankNum: index + 1,
            skuId: item.skuId,
            spuId: item.skuId,
            goodsName: item.title,
          },
        });
      });
      SPM.moduleExpose({
        moduleId: 'platform_moreExchange',
        contentId: 'platform_moreExchange',
        businessInfo: {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.exchange-goods-panel-container {
  background-image:
    linear-gradient(
      180deg,
      #fff7d1 0%,
      #fff 22%,
      #fff 100%
    );
  box-sizing: border-box;
  border: 0.01rem solid #fff;
  border-radius: 0.16rem;
  padding-bottom: 0.15rem;
  margin-bottom: 0.08rem;

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.12rem 0.15rem 0 0.15rem;
    min-height: 0.35rem;

    .header-left {
      display: flex;
      align-items: center;
      max-width: 2.57rem;
    }

    .title {
      font-size: 0.15rem;
      font-weight: 600;
      color: #242729;
      line-height: 0.2rem;
      flex: 0 1 auto;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .header-subtitle {
      display: flex;
      align-items: center;
      margin-left: 0.08rem;
      flex: 0 1 auto;
      min-width: 0;

      .subtitle-logo {
        flex: none;
        width: 0.16rem;
        height: 0.16rem;
        margin-right: 0.02rem;
      }

      .subtitle-text {
        flex: 0 1 auto;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .more-btn {
      display: flex;
      align-items: center;

      .text {
        font-size: 0.12rem;
        line-height: normal;
        color: #879099;
        font-weight: 400;
      }

      .arrow {
        width: 0.12rem;
        height: 0.12rem;
      }
    }
  }

  .panel-content {
    margin-top: 0.1rem;
  }

  .goods-select-list {
    display: flex;
    // align-items: flex-end;
    flex-wrap: nowrap;
    padding: 0 0.2rem;
    justify-content: space-between;

    .goods-select-item {
      position: relative;
      width: 0.84rem;
      transition: width 0.3s ease-in-out, height 0.3s ease-in-out;
      display: flex;
      align-items: center;
      flex-direction: column;

      &:last-child {
        margin-right: 0;
      }

      .goods-logo {
        width: 100%;
        height: 0.54rem;
        vertical-align: bottom;
        border-radius: 0.08rem;
      }

      .goods-tip {
        position: absolute;
        width: 0.66rem;
        height: 0.18rem;
        border-radius: 0 0.09rem 0 0.09rem;
        top: 0.36rem;
        left: 0;
        background-color: rgba(0, 0, 0, 0.6);
        backdrop-filter: blur(0.08rem);
        display: flex;
        align-items: center;
        justify-content: center;

        .goods-tip-text {
          color: #fff;
          font-size: 0.1rem;
        }
      }

      .goods-select-item-bounty {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 0.24rem;
        background-color: #fff4b9;
        border-radius: 0.12rem;
        margin-top: 0.08rem;
        min-width: 0.76rem;
        padding: 0 0.04rem;

        .bounty-icon {
          width: 0.14rem;
          height: 0.14rem;
          margin-right: 0.02rem;
        }

        .bounty-text {
          font-size: 0.12rem;
          line-height: normal;
          color: #000;
          font-weight: 500;
          white-space: nowrap;
        }
      }
    }

    .goods-select-item-selected {
      position: relative;
      width: 0.84rem;

      @keyframes show {
        0% {
          opacity: 0;
        }

        100% {
          opacity: 1;
        }
      }
    }
  }

  .exchange-progress {
    overflow: hidden;
    position: relative;
    margin: 0.1rem auto 0;
    width: 3.36rem;
    height: 0.16rem;
    background-color: #ffebeb;
    border-radius: 0.12rem;

    .exchange-progress-text {
      position: absolute;
      top: 0;
      left: 1.18rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1rem;
      height: 100%;
      font-size: 0.11rem;
      line-height: normal;
      color: #db9a9a;
    }

    .exchange-progress-bar {
      position: relative;
      overflow: hidden;
      width: 0;
      height: 0.16rem;
      background-image: linear-gradient(270deg, #ff3654 0.6%, #ff8798 100%);
      border-radius: 0.12rem 0 0 0.12rem;
      transition: width 0.5s ease;
    }

    .exchange-progress-bar-text {
      position: absolute;
      top: 0;
      left: 1.18rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1rem;
      height: 100%;
      font-size: 0.11rem;
      line-height: normal;
      color: #fff;
    }
  }

  .goods-exchange-tips {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.08rem 0.11rem 0.09rem 0.17rem;

    .tips-text {
      font-size: 0.14rem;
      line-height: 0.2rem;
    }

    .tips-btn {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.76rem;
      height: 0.28rem;
      background-image:
        linear-gradient(
          97.17deg,
          #ff598e 7.46%,
          #f52845 49.23%,
          #ff3c69 70.12%,
          #ff7084 91%
        );
      border-radius: 0.4rem;
      font-size: 0.14rem;
      line-height: normal;
      color: #fff;
    }
  }
}
</style>
